<template>
  <v-dialog
    scrollable
    :value="isVisible"
    max-width="450px"
    persistent
    @input="onDialogInput"
  >
    <v-card>
      <v-card-title class="text-h5">
        Versions
      </v-card-title>
      <v-divider></v-divider>
        <v-card-text>
          <v-progress-linear
            indeterminate
            class="mb-0"
            v-if="items.length!==feeds.length"
          ></v-progress-linear>
          <v-simple-table style="max-width: 310px" fixed-header dense v-else v-slot:default>
            <thead>
            <tr>
              <th scope="col">Feed</th>
              <th scope="col">Version</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in items" >
              <td>
                {{ item.feed }}
              </td>
              <td>
                {{ item.version }}
              </td>
            </tr>
            </tbody>
          </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closePopup">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import config from "../../../config";
import Loader from "../../Loader/Loader.vue";
import persistentDialogEsc from '@/mixins/persistentDialogEsc';

export default {
  name: "FeedsPopup",
  components: { Loader },
  mixins: [
    persistentDialogEsc({
      isVisible: 'closePopup',
    }),
  ],
  props: ["isVisible","game", "feeds", "listVersions"],
  data: function() {
    return {
      items: []
    };
  },
  mounted() {
    this.getVersions(this.game, this.feeds);
  },
  methods: {
    onDialogInput(open) {
      if (!open) {
        this.closePopup();
      }
    },
    closePopup() {
      this.$emit('close');
    },
    getVersions: function(slug, feeds) {
      this.items=[]
      feeds.forEach((feed) => {
        this.$http.get(`${config.apiUrl}/feed/get?feedName=${feed}`)
          .then((responseFeed) => {
            let versionGameInFeed = responseFeed.body.find((g) => g.slug === slug).version;
            if (versionGameInFeed === "active") {
              let gameVersions = this.listVersions.find((g) => g.slug === slug);
              if (!gameVersions) {
                this.items.push({ feed: feed, version: "game isn't executed" });
              } else {
                let activeVersion = gameVersions.versions.find((ver) => ver.active);
                if (!activeVersion) this.items.push({ feed: feed, version: "we don't have active versions" });
                else this.items.push({ feed: feed, version: activeVersion.version + "(active globally)" });
              }
            } else {
              this.items.push({ feed: feed, version: versionGameInFeed + "(not globally active)" });
            }
          }, (error) => {
            console.log(error);
          });
      });
    }
  }
};
</script>
